/* unplugin-vue-components disabled */import { render } from "./RepairInfo.vue?vue&type=template&id=36afaac8&scoped=true"
import script from "./RepairInfo.vue?vue&type=script&lang=js"
export * from "./RepairInfo.vue?vue&type=script&lang=js"

import "./RepairInfo.vue?vue&type=style&index=0&id=36afaac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36afaac8"]])

export default __exports__